import { render, staticRenderFns } from "./protocolVersion.vue?vue&type=template&id=57f6026e&scoped=true"
import script from "./protocolVersion.vue?vue&type=script&lang=js"
export * from "./protocolVersion.vue?vue&type=script&lang=js"
import style0 from "./protocolVersion.vue?vue&type=style&index=0&id=57f6026e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6026e",
  null
  
)

export default component.exports